/**
 * Dependencies.
 */
import { RouteConfig } from 'vue-router';

import { ROUTES } from '@/constants/routes.constant';

/**
 * Export.
 */
export default [
  {
    component: () =>
      import(
        /* webpackChunkName: "chat" */ '@/modules/chat/scenes/chat-detail/chat-detail.scene.vue'
      ),
    meta: { requiresAuth: true },
    name: ROUTES.CHAT.CHAT_DETAIL,
    path: 'chat'
  }
] as RouteConfig[];
